import { useState, useEffect, useCallback } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaStar, FaRegStar, FaChevronLeft, FaChevronRight, FaQuoteLeft } from 'react-icons/fa';
import { TESTIMONIALS } from '../../data/siteData';
import './Testimonials.css';

export default function Testimonials() {
  const [index, setIndex] = useState(0);
  const [direction, setDirection] = useState(1);

  const next = useCallback(() => {
    setDirection(1);
    setIndex((i) => (i + 1) % TESTIMONIALS.length);
  }, []);

  const prev = () => {
    setDirection(-1);
    setIndex((i) => (i - 1 + TESTIMONIALS.length) % TESTIMONIALS.length);
  };

  useEffect(() => {
    const t = setInterval(next, 6000);
    return () => clearInterval(t);
  }, [next]);

  const item = TESTIMONIALS[index];

  return (
    <section className="section section-alt testimonials">
      <div className="container">
        <div className="testimonials__head">
          <p className="eyebrow">Client Voices</p>
          <h2 className="section-title">Trusted By The<br />People We Move For.</h2>
        </div>

        <div className="testimonials__carousel">
          {/* <AnimatePresence mode="wait" initial={false}> */}
            <div
              key={index}
              className="testimonial-card glass"
            >
              <FaQuoteLeft className="testimonial-card__quote-icon" />
              <p className="testimonial-card__quote">{item.quote}</p>
              <div className="testimonial-card__stars">
                {Array.from({ length: 5 }).map((_, i) =>
                  i < item.rating ? <FaStar key={i} /> : <FaRegStar key={i} />
                )}
              </div>
              <div className="testimonial-card__author">
                <span className="testimonial-card__avatar">{item.name.charAt(0)}</span>
                <div>
                  <h4>{item.name}</h4>
                  <p>{item.role}</p>
                </div>
              </div>
            </div>
          {/* </AnimatePresence> */}

          <div className="testimonials__controls">
            <button onClick={prev} aria-label="Previous testimonial"><FaChevronLeft /></button>
            <div className="testimonials__dots">
              {TESTIMONIALS.map((_, i) => (
                <button
                  key={i}
                  className={i === index ? 'is-active' : ''}
                  onClick={() => { setDirection(i > index ? 1 : -1); setIndex(i); }}
                  aria-label={`Go to testimonial ${i + 1}`}
                />
              ))}
            </div>
            <button onClick={next} aria-label="Next testimonial"><FaChevronRight /></button>
          </div>
        </div>
      </div>
    </section>
  );
}
